// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon-with-indicator__dot-indicator--color-info.v-icon,
.icon-with-indicator__dot-indicator--color-info.fa-dot.v-icon {
  color: var(--color-accent-content-base);
}
.icon-with-indicator__dot-indicator--color-info.v-icon:hover,
.icon-with-indicator__dot-indicator--color-info.fa-dot.v-icon:hover {
  color: var(--color-accent-content-base);
}
.icon-with-indicator__dot-indicator--color-warning.v-icon,
.icon-with-indicator__dot-indicator--color-warning.fa-dot.v-icon {
  color: var(--color-warning-content-base);
}
.icon-with-indicator__dot-indicator--color-warning.v-icon:hover,
.icon-with-indicator__dot-indicator--color-warning.fa-dot.v-icon:hover {
  color: var(--color-warning-content-base);
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/common/ui/icon-with-indicator/IconWithIndicator.less"],"names":[],"mappings":"AAEE;;EAEE,uCAAA;AADJ;AAGI;;EACE,uCAAA;AAAN;AAIE;;EAEE,wCAAA;AAFJ;AAII;;EACE,wCAAA;AADN","sourcesContent":[".icon-with-indicator {\n\n  &__dot-indicator--color-info.v-icon,\n  &__dot-indicator--color-info.fa-dot.v-icon {\n    color: var(--color-accent-content-base);\n\n    &:hover {\n      color: var(--color-accent-content-base);\n    }\n  }\n\n  &__dot-indicator--color-warning.v-icon,\n  &__dot-indicator--color-warning.fa-dot.v-icon {\n    color: var(--color-warning-content-base);\n\n    &:hover {\n      color: var(--color-warning-content-base);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
